import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { pathAfterSignIn } from '../utils/googleAuth';

// After a Google popup or redirect, send an existing account to the same place
// email/password login uses. A first-time Google user on the login page goes
// to /signup to choose customer or carrier. On the sign-up forms they stay and
// finish the form.
const useGoogleAuthNavigation = (mode) => {
  const { googleAuthResult, clearGoogleAuthResult } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!googleAuthResult) return;
    const result = googleAuthResult;
    clearGoogleAuthResult();
    if (result.kind === 'needsSetup') {
      if (mode === 'login') navigate('/signup', { replace: true });
      return;
    }
    if (result.kind === 'existing') {
      navigate(pathAfterSignIn({
        type: result.user?.type,
        emailVerified: result.user?.emailVerified,
      }), { replace: true });
    }
  }, [googleAuthResult, clearGoogleAuthResult, navigate, mode]);
};

export default useGoogleAuthNavigation;
